export default __webpack_public_path__ + "static/great-pet-navy-c9fa363095d969ac6c944571b9f7eba1.svg";